const EntityModel = {
  admins: "array",
  review_periods: "array",
  leadership_ids: "array",
  files: "array",
}

export default EntityModel
